import { render, staticRenderFns } from "./uploadTh.vue?vue&type=template&id=2d25d1d6&scoped=true&"
import script from "./uploadTh.vue?vue&type=script&lang=js&"
export * from "./uploadTh.vue?vue&type=script&lang=js&"
import style0 from "./uploadTh.vue?vue&type=style&index=0&id=2d25d1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d25d1d6",
  null
  
)

export default component.exports